import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { getPoolMasterClass } from '../../../../../ECoSystemsHelper';
import { P00041 } from '../../../P00041';
import { P00042 } from '../../../P00042';
import { IProduct } from '../../../../IProduct';
import { Pool } from '../../../../../../../apis/pool.api';

export function P00031TunableMiseEnOeuvreInit(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
): boolean {
  const master = getPoolMasterClass(pool);

  const presenceProduitP00041 = master?.hasProduct(pool, new P00041()) ?? 0;
  const presenceProduitP00042 = master?.hasProduct(pool, new P00042()) ?? 0;

  editValue(
    P00039DataRxTxIndex.Tunable_Controle,
    'tunableCResetManuelProtectionThermique',
    1,
    null,
    productClass,
  );
  editValue(
    P00039DataRxTxIndex.Tunable_Installation,
    'tunableIActivationProtectionThermique',
    1,
    null,
    productClass,
  );

  editValue(
    P00039DataRxTxIndex.Tunable_Controle,
    'tunableCResetManuelProtectionSousTension',
    1,
    null,
    productClass,
  );
  editValue(
    P00039DataRxTxIndex.Tunable_Installation,
    'tunableIActivationProtectionSousTension',
    1,
    null,
    productClass,
  );

  if (presenceProduitP00041 > 0 && presenceProduitP00042 > 0) {
    editValue(
      P00039DataRxTxIndex.Tunable_Installation,
      'tunableISourceVolet',
      1,
      null,
      productClass,
    );
  } else if (presenceProduitP00041 > 0) {
    editValue(
      P00039DataRxTxIndex.Tunable_Installation,
      'tunableISourceVolet',
      2,
      null,
      productClass,
    );
  } else if (presenceProduitP00042 > 0) {
    editValue(
      P00039DataRxTxIndex.Tunable_Installation,
      'tunableISourceVolet',
      1,
      null,
      productClass,
    );
  } else {
    editValue(
      P00039DataRxTxIndex.Tunable_Installation,
      'tunableISourceVolet',
      0,
      null,
      productClass,
    );
  }

  return false;
}
